var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.83 25.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_FILL0_wght400_GRAD0_opsz40",
    d: "m2.36,23.45h1.69l14.46-14.46-1.69-1.69L2.36,21.76v1.69ZM23.52,7.3l-5.01-4.97,1.62-1.66c.92-.89,2.39-.89,3.31,0l1.69,1.69c.44.43.69,1.02.69,1.64.02.61-.21,1.21-.65,1.64l-1.66,1.66Zm-1.69,1.69L5.01,25.81H0v-5.01L16.82,3.98l5.01,5.01Zm-4.16-.85l-.85-.85,1.69,1.69-.85-.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditText);
export default __webpack_public_path__ + "static/media/editText.4dd41e36f7e03d81747a559012540943.svg";
export { ForwardRef as ReactComponent };